// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _rolesNameMap = {
  Admin: "Admin",
  Cliente: "Cliente",
  Tecnico: "Tecnico",
  Laboratorio: "Laboratorio",
  Commerciale: "Commerciale",
  AreaManager: "Area Manager",
  Service: "Service",
} as const;
